import { Button, Form, Input, Modal } from "antd";

const DeletePayoutForm = ({
  isModalOpen = false,
  setIsModalOpen = () => {},
  handleDeletePayout = () => {}
}) => {
  const [form] = Form.useForm();
  const handleSubmit = (values) => {
    handleDeletePayout(values);
    setIsModalOpen(false);
  };

  return (
    <Modal
      title="Why is this payout being deleted?"
      centered
      open={isModalOpen}
      cd
      footer={[]}
      onOk={() => {
        setIsModalOpen(false);
      }}
      onCancel={() => {
        setIsModalOpen(false);
      }}
    >
      <Form form={form} name="payout_deletion_reason_form" onFinish={handleSubmit}>
        <Form.Item
          name="deletionReason"
          label="Reason"
          rules={[
            {
              required: true,
              message: "Please provide the reason for deleting this payout"
            }
          ]}
        >
          <Input
            prefix={<i className="fa fa-ship" aria-hidden="true" />}
            placeholder="false Entry"
          />
        </Form.Item>
        <Form.Item className="submit-btn">
          <Button type="primary" htmlType="submit">
            Delete Payout
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DeletePayoutForm;
